var map = {
	"./de-DE.json": [
		10812,
		[
			812
		]
	],
	"./en-GB.json": [
		43790,
		[
			790
		]
	],
	"./es-ES.json": [
		23150,
		[
			150
		]
	],
	"./fr-FR.json": [
		634,
		[
			634
		]
	],
	"./it-IT.json": [
		87812,
		[
			431
		]
	],
	"./nl-NL.json": [
		18226,
		[
			226
		]
	],
	"./pl-PL.json": [
		17214,
		[
			214
		]
	],
	"./pt-PT.json": [
		33614,
		[
			614
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44782;
module.exports = webpackAsyncContext;